import Hero from "../components/home/Hero.js";
import MissionSection from "../components/home/MissionSection.js";
import PartnerSites from "../components/home/PartnerSites.js";
import Footer from "../components/home/Footer.js";
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <div id="mission">
        <MissionSection />
      </div>
      <div id="partners">
        <PartnerSites />
      </div>
      <div id="contact">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
